<template>
    <NuxtLayout name="main" :dark="true" :favorite="true">
        <!-- * 确认窗口 -->
        <confirm-modal ref="confirm" @confirm="methods.confirm" :content="$t('PredictionMutationDELConfirm')" />
        <!-- * 内容 -->
        <div :class="css.container" class="w-[1520px] max-lg:w-[1360px] mx-auto mt-[120px] max-lg:mt-[52px]">
            <!-- * 工具名称 -->
            <section class="font-bold color-1 text-center text-[40px] leading-[72px]">{{ $t("RNASplicer") }}</section>
            <!-- * 工具简介 -->
            <section class="mt-[4px] leading-[22px] text-center">
                <p>{{ $t("RNASplicerDescript2") }}</p>
                <p>{{ $t("RNASplicerDescript3") }}</p>
            </section>

            <!-- * 工具内容 -->
            <section class="mt-[48px] max-lg:mt-[40px]">
                <module-mutations-inputs ref="inputs" mode="Rna" />
            </section>

            <!-- * 工具底部 -->
            <section class="text-center">
                <!-- * 分割线 -->
                <div class="my-[32px] max-lg:my-[24px] w-[100%] h-[1px] bg-color10"></div>
                <!-- * 提交按钮 -->
                <ui-button :width="144" @click="methods.submit">{{ $t("Submit") }}</ui-button>
            </section>
        </div>
    </NuxtLayout>
</template>

<script lang="ts" setup>
//* 组件库
import { $loading, UiButton } from "various-ui";
//* 公共组件
import { ConfirmModal } from "@/components/windows";
//* 全局函数
import { Formats } from "@/assets/js";
//* 私有组件
import ModuleMutationsInputs from "@/views/tool/components/mutations-inputs/index.vue";
import type { ModuleFormData } from "@/views/tool/components/mutations-inputs/src/types";
//* 样式
import css from "./index.module.less";

//* 插件
const i18n = useI18n();
const route = useRoute();
//* 表单节点
const inputs = ref<InstanceType<typeof ModuleMutationsInputs>>();
//* 确认窗口组件
const confirm = ref<InstanceType<typeof ConfirmModal>>();

//* 函数列表
const methods = {
    //* 提交函数
    submit: () => {
        inputs.value?.submit((datas) => {
            if (datas.find((v) => !v.alt)) confirm.value?.open(datas);
            else {
                methods.confirm(datas);
            }
        });
    },

    //* 确认函数
    confirm: (datas: ModuleFormData[]) => {
        console.log("表单提交数据：", datas);
        //* 数据处理
        $loading.open({ message: i18n.t("UnderLoad"), delay: 200 });
        const data = datas.map((v) => {
            return {
                ref: v.ref,
                alt: v.alt,
                name: v.name,
                gene_id: v.id,
                gene_pos: v.data.range?.start || -1,
                transcript_id: v.transcript,
            };
        });

        //* 接口请求
        api.frontend("/api/ai/splicer", {
            data: { data: data },
            method: "POST",
            finally: () => $loading.close(),
            success: (response) => {
                window.open(routerResolve({ name: "RnaSplicerResult", params: { id: response } }).href, "_blank");
            },
        });
    },
};

//* 组件挂载时通过URL参数获取数据
onMounted(() => {
    const uid = Formats.query(route.query.uuid);
    if (!uid) return;
    else {
        $loading.open({ message: "" });
        api.frontend("/api/bio/variant/params", {
            data: { id: uid },
            error: () => $loading.close(),
            hidden: true,
            success: (response) => {
                //* 表单初始化
                nextTick(() => {
                    inputs.value?.init(response);
                });
            },
        });
    }
});
</script>
